exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RestoreDeletedPatientsDialogContent__marquee___mfPYz {\n  margin: 0 var(--vds-space-xs) var(--vds-space-xs);\n}\n.RestoreDeletedPatientsDialogContent__datagrid___2Nlei.RestoreDeletedPatientsDialogContent__datagrid___2Nlei {\n  border-top: 0px;\n  border-left: 0px;\n  border-right: 0px;\n  border-radius: var(--vds-border-radius-0);\n}\n", ""]);

// exports
exports.locals = {
	"marquee": "RestoreDeletedPatientsDialogContent__marquee___mfPYz",
	"datagrid": "RestoreDeletedPatientsDialogContent__datagrid___2Nlei"
};